module.exports = {
    "source_code": "HLXEMS",
    "site_id": "info.bme.jhu.edu",
    "title": "Johns Hopkins University",
    "tfn": "",
    "url": "https://info.bme.jhu.edu",
    "gtm_code": "GTM-KKXZBSVV",
}